export enum UserAppStep {
    LOGIN = "LOGIN",
    PERMISSION = "PERMISSION",
    PREPARING = "PREPARING",
    ON_CALL = "ON_CALL",
    END_CALL = "END_CALL",
    RECONNECTING = "RECONNECTING"
  }
  